(ns nl.mediquest.be-my-coach-frontend.views.map.leaflet-interop
  (:require
   ["leaflet" :refer [latLngBounds]]
   ["react" :refer [useRef useEffect]]
   ["react-leaflet" :refer [MapContainer TileLayer Marker Popup useMap]]
   [nl.mediquest.be-my-coach-frontend.config :as config]))

(defn zorgverlener->latlng
  [{:keys [latitude longitude] :as _zorgverlener}]
  {:lat latitude :lng longitude})

(defn keep-markers-in-view
  "Returns an empty react component, but reacts to marker updates, keeping them
   in view. Bit hacky, (useMap) needs the react context."
  [markers]
  (let [leaflet-map (useMap)
        latlngs (map zorgverlener->latlng @markers)
        bounds (latLngBounds (clj->js latlngs))]
    (.fitBounds leaflet-map (.pad bounds 0.1))
    [:<>]))

(defn popup-auto-open-props-maker
  [open? close-fn]
  {:open? open?
   :interactive true
   :event-handlers
   {:remove close-fn}})

(defn- open-close-popup-react-effect
  "Creates a react effect that, when `open` is true, opens `popup-ref` and
   returns a cleanup hook to useEffect that closes `popup-ref`. Returns
   `js/undefined` when there is nothing to clean up - React 19 calls back
   anything that is not `undefined`, so a `nil` return throws.
   See [useEffect](https://react.dev/reference/react/useEffect) for details."
  [open? ^js popup-ref]
  (useEffect
   (fn []
     (if-let [^js source (when open? (some-> (.-current popup-ref) .-_source))]
       (do (.openPopup source)
           #(.closePopup source))
       js/undefined))
   #js [open? popup-ref]))

(defn reactive-popup
  [{:keys [open?] :as opts} body]
  (let [^js popup-ref (useRef)]
    (open-close-popup-react-effect open? popup-ref)
    [:> Popup
     (assoc opts :ref popup-ref)
     body]))

(defn hover-and-click-marker-handler-maker
  [toggle-fn]
  {:mouseover
   #(this-as this
      (.openPopup this))
   :click toggle-fn})

(defn marker
  [{:keys [position] :as opts} body]
  [:> Marker
   (assoc opts :position (clj->js position))
   body])

(def ^:private default-map-opts
  {:center {:lat 52.0332760 :lng 5.6615557}
   :scrollWheelZoom true
   :zoom 13
   :maxZoom 18
   :style {:width "100%" :height "100%"}})

(def ^:private tile-opts
  (if config/TOMTOM_API_KEY
    config/tomtom-tile-opts
    {:url "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
     :attribution "&copy; <a href=\"https://www.openstreetmap.org/copyright\">OpenStreetMap</a> contributors"}))

(defn base-map
  [body]
  [:> MapContainer default-map-opts
   body
   [:> TileLayer tile-opts]])
